import { flowIdRiskAnalysisBE, flowIdRiskAnalysisNL, flowIdRiskAnalysisShortBE } from "../../../flows/src/constants/flowIds";

const useIsRiskAnalysisFlow = (flowId: string): boolean => {
  switch(flowId) {
    case flowIdRiskAnalysisBE:
    case flowIdRiskAnalysisShortBE:
    case flowIdRiskAnalysisNL:
      return true;
    default:
      return false;
  }
}

export default useIsRiskAnalysisFlow;